import React from 'react';
import { ArrowRight, Zap, Smartphone } from 'lucide-react';
import Button from '@/components/ui/Button';
import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center pt-24 pb-16 overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-white to-slate-50" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_20%,rgba(142,227,205,0.3)_0%,rgba(255,255,255,0)_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_80%,rgba(155,135,245,0.2)_0%,rgba(255,255,255,0)_60%)]" />

      {/* Dotted pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(#2b825b 1px, transparent 1px)',
        backgroundSize: '20px 20px'
      }} />

      <div className="container px-4 mx-auto relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
                Transformez votre vision en <span className="text-orcsys-500">application mobile</span> performante
              </h1>

              <p className="text-lg text-slate-600 mb-8">
                Nous concevons et développons des applications mobiles innovantes, intuitives et évolutives
                qui répondent aux besoins de vos utilisateurs et aux objectifs de votre entreprise.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <Button.Link
                  href="#estimation"
                  size="lg"
                  className="bg-orcsys-500 hover:bg-orcsys-600 text-white group"
                >
                  Demander un devis gratuit
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </Button.Link>
              </div>

              <div className="flex items-center space-x-2 text-slate-600">
                <Zap className="w-5 h-5 text-orcsys-500" />
                <span>Livraison jusqu'à 40% plus rapide que la moyenne du marché</span>
              </div>
            </motion.div>

            {/* Phone mockup */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="relative mx-auto lg:mx-0 max-w-[320px] lg:max-w-none h-[500px] lg:h-[560px] hidden lg:block"
            >
              <div className="relative h-full">
                <motion.div
                  className="absolute top-0 left-0 w-full h-full"
                  animate={{
                    rotate: [-2, 2, -2],
                    y: [0, -5, 0]
                  }}
                  transition={{
                    duration: 6,
                    repeat: Infinity,
                    repeatType: "reverse",
                    ease: "easeInOut"
                  }}
                >
                  <div className="relative border-[10px] border-slate-800 rounded-[40px] shadow-2xl overflow-hidden 
                    h-[510px] w-[260px] mx-auto"
                  >
                    
                    <img
                      src="images/mobile-2.png"
                      alt="Mobile App Interface"
                      className="w-full h-full object-fill object-center mix-blend-overlay"
                    />

                  </div>
                </motion.div>

                {/* Second phone */}
                <motion.div
                  className="absolute bottom-0 right-0 lg:-right-10 z-10"
                  animate={{
                    rotate: [2, -2, 2],
                    y: [0, 5, 0]
                  }}
                  transition={{
                    duration: 7,
                    repeat: Infinity,
                    repeatType: "reverse",
                    ease: "easeInOut"
                  }}
                >
                  <div className="relative border-[10px] border-slate-800 rounded-[40px] shadow-2xl overflow-hidden 
                    h-[450px] w-[230px]"
                  >
                    <div className="absolute top-0 left-0 w-full h-full" />
                    <img
                      src="images/mobile-1.png"
                      alt="Mobile App Interface"
                      className="w-full h-full object-fill object-center mix-blend-overlay"
                    />
                  </div>
                </motion.div>

                {/* Decorative elements */}
                <div className="absolute -top-10 -left-10 w-20 h-20 bg-orcsys-500/10 rounded-full blur-xl" />
                <div className="absolute -bottom-10 -right-10 w-20 h-20 bg-orcsys-500/10 rounded-full blur-xl" />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 